<template>
  <el-select
    v-model="benefit"
    :loading="loading"
    :remote-method="getAll"
    :disabled="disable"
    :remote="true"
    :key="keys"
    filterable
    clearable
    placeholder="Select Benefits"
    @clear="updateParent"
    @change="updateParent">
    <el-option v-for="benefit in benefits" :key="benefit.id" :value="benefit.id" :label="benefit.name+ ' ( ' + benefit.desc + ' ) '">{{ benefit.name + ' ( ' + benefit.desc + ' ) ' }}</el-option>
  </el-select>
</template>

<script>
import { Benefits } from '@/api/payroll/benefits'

export default {
  name: 'SelectBenefits',
  props: {
    benef: {
      default: null,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    type: {
      default: 'default',
      type: String
    }
  },
  data() {
    return {
      loading: false,
      selected: {},
      defaultbenefit: {
        id: -1,
        name: 'default',
        desc: 'Select Benefits'
      },
      benefits: [],
      benefit: null,
      keys: 0
    }
  },
  watch: {
    benef: function(item) {
      this.benefit = item
      this.benefits = item ? [item] : []
      this.keys++
    }
  },
  created() {
    this.benefits = this.benefits.filter(function(element) {
      return element !== undefined
    })
    if (this.benefit) {
      this.benefits = [this.defaultbenefit, this.benef]
      this.benefit = this.benef
    }
    this.getDefault()
  },
  methods: {
    updateParent(id) {
      this.$emit('setBenefit', id)
    },
    getAll(query) {
      if (query.length > 2) {
        this.loading = true
        setTimeout(() => {
          Benefits({ per_page: 9999, term: query, type: this.type }, 'get').then(res => {
            this.benefits = res.data.benefits
            this.loading = false
          }).catch(() => {})
        }, 100)
      } else {
        this.benefits = []
      }
    },
    getDefault(query) {
      setTimeout(() => {
        Benefits({ per_page: 9999, term: query, type: this.type }, 'get').then(res => {
          this.benefits = res.data.benefits
          this.loading = false
        }).catch(() => {})
      }, 100)
    }
  }
}
</script>
